import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { apiEndpoints } from '../endpoints';
import { queryKeys } from '../react-query.config';

export interface ScoringStatus {
  isScoring: boolean;
  pickemId?: string;
  pickemName?: string;
  pickemLocation?: string;
  progress?: {
    current: number;
    total: number;
    percentage: number;
  };
}

export async function getScoringStatus(): Promise<ScoringStatus> {
  try {
    // Note: api.get returns response.data directly due to response interceptor
    const data = await api.get(apiEndpoints.scoringStatus);

    // Ensure we always return a valid object
    if (!data) {
      return { isScoring: false };
    }

    return data as unknown as ScoringStatus;
  } catch (error) {
    console.error('[getScoringStatus] Error fetching scoring status:', error);
    // Return default value on error
    return { isScoring: false };
  }
}

export function useScoringStatusQuery(refetchInterval: number = 5000) {
  return useQuery({
    queryKey: queryKeys.pickems.scoringStatus,
    queryFn: getScoringStatus,
    refetchInterval, // Poll every 5 seconds by default
  });
}
